// CoveragesDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import CoveragesForm from './CoveragesForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function CoveragesDialog({ model, setModel, targetType, target }) {
  const [submodel, setSubmodel] = useState()
  const [landUseIDs, setLandUseIDs]   = useState((Object.keys(model.LANDUSES).length===0?[]:Object.keys(model.LANDUSES)))
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    // Create a group of empty coverages for each type of landuse
    let COVERAGES = {[target]:{}}
    landUseIDs.forEach((id) => 
      COVERAGES[target][id] = {
        Percent: '0'
      }
    )

    if(model.COVERAGES && model.COVERAGES[target]){
      COVERAGES = {
        [target]: {
          ...COVERAGES[target],
          ...model.COVERAGES[target]
        }
      }
    }

    setSubmodel({
      COVERAGES: COVERAGES
    })
    
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      COVERAGES:{
        ...prev.COVERAGES, 
        [target]: {
          ...cleanSub.COVERAGES[target]
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Coverages for Subcatchment {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <CoveragesForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}